import React from 'react';

import { IAbstractRecord } from '@models';
import { TableCell, TableRow } from '@mui/material';
import { MAIN_THEME } from '@styles';

import { makeStyles } from 'tss-react/mui';

interface IEmptyHeader {
  width: number;
  height: number;
  classes: IAbstractRecord;
  children: React.ReactNode;
}

const useStyles = makeStyles()(() => ({
  noDataCell: {
    color: MAIN_THEME.color.black,
    border: 'none',
    height: '34px',
    fontSize: MAIN_THEME.fontSize.sm,
    lineHeight: '12px',
    fontFamily: MAIN_THEME.font.regular
  }
}));

const EmptyTableRow: React.FC<IEmptyHeader> = ({ children, width, height }) => {
  const { classes } = useStyles();

  return (
    <TableRow>
      <TableCell
        rowSpan={2}
        colSpan={width > 0 ? width + 1 : 1}
        style={{ height: height }}
        align="center"
        classes={{ root: classes.noDataCell }}
      >
        {children}
      </TableCell>
    </TableRow>
  );
};

export default EmptyTableRow;
